import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Dashboard from "@/pages/Dashboard";
import OpportunityDetails from "@/pages/OpportunityDetails";

function App() {
  return (
    <div className="App">
      <BrowserRouter basename={process.env.PUBLIC_URL || "/"}>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/opportunity/:id" element={<OpportunityDetails />} />
          <Route path="*" element={<Dashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster 
        position="bottom-right" 
        richColors 
        closeButton
        toastOptions={{
          duration: 3000,
        }}
      />
    </div>
  );
}

export default App;
